import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { SuperAdminService } from "src/app/super-admin.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { debounce } from "lodash";

@Component({
  selector: "app-views-tracker",
  templateUrl: "./views-tracker.component.html",
  styleUrls: ["./views-tracker.component.css"],
})
export class ViewsTrackerComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    "Tracker_no",
    "date",
    "vehicle_id",
    "created_by",
    "company",
    "vehicle_Types",
    "from",
    "to",
    "fixAdhoc",
    "startmeterReading",
    "endmeterReading",
    "tripStartDate",
    "tripEndDate",
    "noofTools",
    "up_down_km",
    "extrahour",
    "totalExpense",
    "action",
  ];

  dataSource = new MatTableDataSource<any>([]);
  totalRecords = 0;
  currentPage = 1;
  pageSize = 10;
  searchTerm = "";
  fromDate = "";
  toDate = "";
  userSessionData: any = {};
  receipts: any[] = [];
  isAdmin: boolean = false;
  isSuperSupervisor: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  filterData = debounce((value: string) => {
    this.searchTerm = value.trim();
    this.currentPage = 1;
    this.paginator?.firstPage();
    this.loadTrackers();
  }, 400);

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.userSessionData = JSON.parse(
      sessionStorage.getItem("userSession") || "{}"
    );
    const roleIds = this.userSessionData?.user_role_id || [];
    this.isAdmin = roleIds.includes(1);
    this.isSuperSupervisor = roleIds.includes(7);

    this.loadTrackers();
  }

  ngAfterViewInit(): void {
    // this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadTrackers(): void {
    this.spinner.show();

    const roleIds = this.userSessionData?.user_role_id || [];
    const isSupervisor = roleIds.includes(2);
    const supervisorId = this.userSessionData?._id;

    const apiCall = isSupervisor
      ? this.superAdminService.getTrackersBySupervisor(
          supervisorId,
          this.currentPage,
          this.pageSize,
          this.searchTerm,
          this.fromDate,
          this.toDate
        )
      : this.superAdminService.getTrackers(
          this.currentPage,
          this.pageSize,
          this.searchTerm,
          this.fromDate,
          this.toDate
        );

    apiCall.subscribe({
      next: (res: any) => {
        if (res.status) {
          const rawData = res.data || [];
          this.receipts = rawData;
          this.dataSource = new MatTableDataSource(this.receipts);

          this.dataSource.paginator = null;
          this.dataSource.sort = this.sort;

          this.totalRecords = res.pagination?.total || this.receipts.length;
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.dataSource.data = [];
          this.totalRecords = 0;
          this.toastr.error(res.message || "Error fetching data");
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error("Failed to load tracker data!");
      },
    });
  }

  // Pagination
  onPageChange(e: any) {
    this.currentPage = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.loadTrackers();
  }

  // Date range
  onDateChange(event: any, type: "from" | "to") {
    if (type === "from") this.fromDate = event.target.value;
    else this.toDate = event.target.value;

    this.currentPage = 1;
    this.paginator?.firstPage();
    this.loadTrackers();
  }

  sortData(sort: Sort) {
    const data = [...this.dataSource.data];
    if (!sort.active || sort.direction === "") return;

    const isAsc = sort.direction === "asc";

    const compare = (a: any, b: any) => (a < b ? -1 : 1) * (isAsc ? 1 : -1);

    this.dataSource.data = data.sort((a, b) => {
      const key = sort.active;

      if (typeof a[key] === "string") {
        return compare(
          a[key]?.toLowerCase() || "",
          b[key]?.toLowerCase() || ""
        );
      }
      return compare(a[key], b[key]);
    });
  }

  exportToExcel(): void {
    this.spinner.show();

    this.superAdminService
      .exportTrackers(this.searchTerm, this.fromDate, this.toDate)
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();

          if (!res.status || !res.rawdata || res.rawdata.length === 0) {
            this.toastr.warning("No data to export!");
            return;
          }

          const fullData = res.rawdata;

          const exportData = fullData.map((item: any) => ({
            Tracker_no: item.Tracker_no,
            Supervisor: item.supervisorName || "",
            Date: item.date ? new Date(item.date).toLocaleDateString() : "",
            "Company Name": item.clientName || "",
            "Vehicle No": item.vehicle_id,
            "Vehicle Type": item.vehicleType,
            "Fix/Adhoc": item.fixAdhoc,
            From: item.from,
            To: item.to,
            "Start Meter Reading": item.startmeterReading,
            "End Meter Reading": item.endmeterReading,
            "Trip Start Date": item.tripStartDate
              ? new Date(item.tripStartDate).toLocaleDateString()
              : "",
            "Trip End Date": item.tripEndDate
              ? new Date(item.tripEndDate).toLocaleDateString()
              : "",
            "Trip Out Time": item.out_time,
            "Trip In Time": item.in_time,
            "Number of Tolls": item.noofTools,
            "Toll Tax Paid": item.tooltaxPaid,
            "Usage KM": item.up_down_km,
            "Total Hours": item.totalhour,
            "Extra Hours": item.extrahour,
            DLY: item?.dly_no || "",
            "Order ID": item?.orderId || "",
            "Vehicle Rate": item?.vehicleRate || "",
            Advance: item?.advance || "",
            Balance: item?.balance || "",
            "Balance Paid": item?.balancePaid || "",
            TDS: item?.TDS || "",
            "Munsipal Amount ": item?.munsipalAmount,
            "Other Payment": item?.otherPayment,
            "Final Amount": item?.finalAmount || "",
            "Total Expense": item?.totalExpense || "",
          }));

          const ws = XLSX.utils.json_to_sheet(exportData);
          const wb = { Sheets: { Trackers: ws }, SheetNames: ["Trackers"] };
          const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

          saveAs(
            new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            `TrackerData_${new Date().toISOString().slice(0, 10)}.xlsx`
          );
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error("Export failed!");
        },
      });
  }

  // delete logic
  deleteuser(email: string) {
    this.superAdminService.deleteuser(email).subscribe({
      next: (res) => {
        if (res.status) {
          alert(res.message);
          this.loadTrackers();
        }
      },
    });
  }

  emitdata(params: any) {
    sessionStorage.setItem("userdata", JSON.stringify(params));
  }

  backTo() {
    window.history.back();
  }

  clearFilters() {
    this.searchTerm = "";
    this.fromDate = "";
    this.toDate = "";

    // Reset page
    this.currentPage = 1;

    // Clear input fields
    const fromInput = document.getElementById("fromDate") as HTMLInputElement;
    const toInput = document.getElementById("toDate") as HTMLInputElement;
    const searchInput = document.querySelector(
      "input.search-box"
    ) as HTMLInputElement;

    if (fromInput) fromInput.value = "";
    if (toInput) toInput.value = "";
    if (searchInput) searchInput.value = "";

    // Load default data
    this.loadTrackers();

    // Reset paginator visually
    this.paginator?.firstPage();
  }

  deleteTracker(receipt: any): void {
    if (!receipt?._id) return;

    const confirmDelete = confirm(
      `Are you sure you want to delete Tracker ${receipt.Tracker_no}?`
    );

    if (!confirmDelete) return;

    this.spinner.show();

    this.superAdminService.deleteLR(receipt._id).subscribe({
      next: (res) => {
        this.spinner.hide();

        if (res.status) {
          this.toastr.success(res.message || "Tracker deleted successfully");
          this.loadTrackers(); // ✅ correct reload
        } else {
          this.toastr.error(res.message || "Failed to delete Tracker");
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error("Delete failed!");
      },
    });
  }
}
